import { useAtomValue } from 'jotai'
import React from 'react'
import * as R from 'remeda'

import { useSurveyQueryBrandGroups } from '~/hooks/useSurveyQuery'
import { intersectionBy } from '~/utils'

import { tabulatedBrandIdsAtom } from '../atoms'

export const useTabulatedBrands = () => {
  const tabulatedBrandIds = useAtomValue(tabulatedBrandIdsAtom)
  const brandGroups = useSurveyQueryBrandGroups()

  return React.useMemo(
    () =>
      R.pipe(
        brandGroups,
        R.flatMap(R.prop('brands')),
        intersectionBy(tabulatedBrandIds, R.prop('id'), R.identity()),
      ),
    [brandGroups, tabulatedBrandIds],
  )
}
